import apiClient from "@/services/api-client";

export type TenantControlProfilePayload = {
  legalName?: string;
  tradeName?: string;
  complianceStatus?: string;
  dataResidency?: string;
  retentionDays?: number;
  supportTier?: string;
  customerSuccessOwner?: string;
  billingEmail?: string;
  securityEmail?: string;
  reason: string;
};

export const tenantControlService = {
  get: async (tenantId: string) =>
    (await apiClient.get(`/tenants/${tenantId}/control-plane`)).data,
  updateProfile: async (tenantId: string, payload: TenantControlProfilePayload) =>
    (await apiClient.patch(`/tenants/${tenantId}/control-profile`, payload)).data,
  createContact: async (tenantId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/tenants/${tenantId}/control-contacts`, payload)).data,
  removeContact: async (tenantId: string, contactId: string, reason: string) =>
    (await apiClient.delete(`/tenants/${tenantId}/control-contacts/${contactId}`, { data: { reason } })).data,
  createDomain: async (tenantId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/tenants/${tenantId}/control-domains`, payload)).data,
  removeDomain: async (tenantId: string, domainId: string, reason: string) =>
    (await apiClient.delete(`/tenants/${tenantId}/control-domains/${domainId}`, { data: { reason } })).data,
  createDataRequest: async (tenantId: string, requestType: "EXPORT" | "DELETE", reason: string) =>
    (await apiClient.post(`/tenants/${tenantId}/data-requests`, { requestType, reason })).data,
  cancelDataRequest: async (tenantId: string, requestId: string, reason: string) =>
    (await apiClient.post(`/tenants/${tenantId}/data-requests/${requestId}/cancel`, { reason })).data,
};
